import styles from './styles.module.scss';
export const classes = {
  default: `${styles.default}`,
  News: `${styles.default}`,
  workstation: `${styles.workstation}`,
  parking: `${styles.parking}`,
  workroom: `${styles.workroom}`,
};
